import React from 'react';

const LoadingScreen = () => {
  return (
    <div className="fixed inset-0 bg-white flex items-center justify-center z-50">
      <div className="text-center">
        <div className="mb-8">
          <svg 
            width="80" 
            height="92" 
            viewBox="0 0 51 58" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            className="mx-auto drop-shadow-lg animate-zoom"
          >
            <path 
              d="M5.06435 10.879C2.70352 5.80757 6.40601 0 12 0V0L39 58H34.6503C29.9839 58 25.7407 55.2948 23.7713 51.0644L5.06435 10.879Z" 
              fill="url(#paint0_linear_2_21)"
            />
            <path 
              d="M0 12C0 5.37258 5.37258 0 12 0V0V46C12 52.6274 6.62742 58 0 58V58V12Z" 
              fill="#08BC44"
            />
            <path 
              d="M51 0H45.5C41.9101 0 39 2.91015 39 6.5V6.5V58V58C45.6274 58 51 52.6274 51 46V0Z" 
              fill="#08BC44"
            />
            <defs>
              <linearGradient 
                id="paint0_linear_2_21" 
                x1="21.5" 
                y1="0" 
                x2="21.5" 
                y2="58" 
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#09AE3F"/>
                <stop offset="1" stopColor="#05792E"/>
              </linearGradient>
            </defs>
          </svg>
        </div>
        
        <div className="space-y-3 animate-fade-in">
          <h2 className="text-3xl font-bold text-gray-800">nServers</h2>
          <p className="text-gray-600">Carregando Ferramentas...</p>
        </div>
        
        <div className="mt-8 flex justify-center">
          <div className="relative">
            <div className="w-12 h-12 border-4 border-gray-200 rounded-full"></div>
            <div className="absolute top-0 left-0 w-12 h-12 border-4 border-green-500 border-t-transparent rounded-full animate-spin"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen; 